import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader2 } from 'lucide-react';

const ApplicationMain = () => {
  const [searchParams] = useSearchParams();
  const [customerId, setCustomerId] = useState(null);

  useEffect(() => {
    const id = searchParams.get('customerid');
    if (id) {
      setCustomerId(id);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2B0A12] via-[#3D1C24] to-[#2B0A12] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        {customerId ? (
          <>
            <div className="mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-12 h-12 text-green-600" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#2B0A12] mb-4">
                Application Submitted Successfully!
              </h1>
              <p className="text-lg text-gray-600 mb-6">
                Thank you for choosing our trademark registration services. Your application has been received.
              </p>
            </div>

            <div className="bg-gradient-to-r from-[#FFB400]/10 to-[#D72638]/10 rounded-xl p-6 mb-8">
              <p className="text-sm text-gray-600 mb-2">Your Customer ID</p>
              <p className="text-3xl font-bold text-[#D72638]">{customerId}</p>
            </div>

            <div className="text-left space-y-4 mb-8">
              <h2 className="text-xl font-bold text-[#2B0A12] mb-4">What Happens Next?</h2>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-8 h-8 bg-[#FFB400] rounded-full flex items-center justify-center text-white font-bold text-sm">1</div>
                <div>
                  <h3 className="font-semibold text-gray-800">Application Review</h3>
                  <p className="text-sm text-gray-600">Our expert team will review your application within 24-48 hours.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-8 h-8 bg-[#FFB400] rounded-full flex items-center justify-center text-white font-bold text-sm">2</div>
                <div>
                  <h3 className="font-semibold text-gray-800">Confirmation Email</h3>
                  <p className="text-sm text-gray-600">You'll receive a confirmation email with next steps and timeline.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-8 h-8 bg-[#FFB400] rounded-full flex items-center justify-center text-white font-bold text-sm">3</div>
                <div>
                  <h3 className="font-semibold text-gray-800">Personal Consultation</h3>
                  <p className="text-sm text-gray-600">A trademark specialist will contact you to discuss your case in detail.</p>
                </div>
              </div>
            </div>

            <div className="border-t pt-6">
              <p className="text-sm text-gray-600">
                If you have any immediate questions, please contact us at{' '}
                <a href="tel:+18882031297" className="text-[#D72638] font-semibold hover:underline">+1 (888) 203-1297</a>
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="mb-6">
              <Loader2 className="w-16 h-16 text-[#FFB400] animate-spin mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-[#2B0A12]">Processing...</h1>
              <p className="text-gray-600 mt-2">Please wait while we verify your information.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ApplicationMain;
